'use client';

import { useState, useEffect } from 'react';
import Link from "next/link";
import { useRouter, usePathname } from "next/navigation";
import { useTranslations } from "next-intl";
import { checkAuth, isAdmin } from "../lib/auth";

export default function Header() {
  const router = useRouter();
  const pathname = usePathname();
  const t = useTranslations('common');
  
  // 提取当前语言代码
  const currentLocale = pathname.match(/^\/([a-z]{2}-[A-Z]{2})/)?.[1] || 'zh-CN';
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<any>(null);
  const [admin, setAdmin] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [settings, setSettings] = useState({
    siteName: '企业名称',
    siteEmail: 'info@example.com',
    sitePhone: '400-123-4567',
    siteAddress: '北京市朝阳区某某大厦'
  });

  // 切换语言
  const switchLanguage = (locale: string) => {
    // 提取当前路径（不包含语言代码）
    const currentPath = pathname.replace(/^\/[a-z]{2}-[A-Z]{2}/, '') || '/';
    // 导航到新语言的相同路径
    router.push(`/${locale}${currentPath}`);
  };

  useEffect(() => {
    // 检查认证状态
    const { isAuthenticated: auth, user: userData } = checkAuth();
    setIsAuthenticated(auth);
    setUser(userData);
    setAdmin(isAdmin());

    // 获取设置
    const fetchSettings = async () => {
      try {
        const response = await fetch('/api/settings');
        if (!response.ok) {
          throw new Error('Failed to fetch settings');
        }
        const data = await response.json();
        setSettings(data);
      } catch (err) {
        console.error('Error fetching settings:', err);
      }
    };

    fetchSettings();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = `/${currentLocale}`;
  };

  return (
    <header className="bg-white shadow-md">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link href={`/${currentLocale}`} className="text-2xl font-bold text-blue-600">{settings.siteName}</Link>
        <div className="flex items-center space-x-8">
          <nav>
            <ul className="flex space-x-8">
              <li><Link href={`/${currentLocale}`} className="text-black hover:text-blue-600 transition-colors">{t('home')}</Link></li>
              <li><Link href={`/${currentLocale}/about`} className="text-black hover:text-blue-600 transition-colors">{t('about')}</Link></li>
              <li><Link href={`/${currentLocale}/products`} className="text-black hover:text-blue-600 transition-colors">{t('products')}</Link></li>
              <li><Link href={`/${currentLocale}/news`} className="text-black hover:text-blue-600 transition-colors">{t('news')}</Link></li>
              <li><Link href={`/${currentLocale}/contact`} className="text-black hover:text-blue-600 transition-colors">{t('contact')}</Link></li>
              {isAuthenticated ? (
                <>
                  {admin && (
                    <li><Link href={`/${currentLocale}/admin`} className="text-black hover:text-blue-600 transition-colors">{t('admin')}</Link></li>
                  )}
                  <li className="relative">
                    <button 
                      onClick={() => setIsMenuOpen(!isMenuOpen)}
                      className="text-black hover:text-blue-600 transition-colors flex items-center"
                    >
                      {user?.name || 'User'}
                      <span className="ml-1">▼</span>
                    </button>
                    {isMenuOpen && (
                      <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50">
                        <div className="py-1">
                          <button 
                            onClick={handleLogout}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                          >
                            {t('logout')}
                          </button>
                        </div>
                      </div>
                    )}
                  </li>
                </>
              ) : (
                <>
                  <li><Link href={`/${currentLocale}/login`} className="text-black hover:text-blue-600 transition-colors">{t('login')}</Link></li>
                  <li><Link href={`/${currentLocale}/register`} className="text-black hover:text-blue-600 transition-colors">{t('register')}</Link></li>
                </>
              )}
            </ul>
          </nav>
          
          {/* 语言切换 */}
          <div className="flex space-x-2">
            <button 
              onClick={() => switchLanguage('zh-CN')}
              className="px-3 py-1 text-sm border border-gray-300 rounded-md hover:bg-gray-100 transition-colors"
            >
              中文
            </button>
            <button 
              onClick={() => switchLanguage('en-US')}
              className="px-3 py-1 text-sm border border-gray-300 rounded-md hover:bg-gray-100 transition-colors"
            >
              English
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
